export default "__VITE_ASSET__eb8c0c09__"